import React from 'react'

function DecowoodPdf() {
    return (
        <embed src="/pdfs/DECOWOOD.pdf" width="100%" height="2100px" />
    )
}

export default DecowoodPdf